import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import root from 'window-or-global';
import {navReady, footerReady} from '@epic-core/common';
import jQuery from 'jquery';
import {getOrigin} from '../../constants';

const DIV_CONTAINER_ID = '__external_';
const EG_HEADER = 'epic-enterprise-header';
const EG_FOOTER = 'epic-games-footer';

const mapStateToProps = state => {
    let user = state.get('user');
    let config = state.get('config');
    user = user ? user.toJS() : {};
    config = config ? config.toJS() : {};
    return {
        userState: user,
        configState: config
    };
};

@connect(mapStateToProps)
export default class ExternalScript extends React.Component {
    state = {
        data: ''
    };

    static propTypes = {
        userState: PropTypes.object,
        configState: PropTypes.object,
        type: PropTypes.string,
        lang: PropTypes.string
    };

    static defaultProps = {
        type: '',
        lang: 'en-US'
    };

    getRequestUrl = () => {
        const type = this.props.type;
        const lang = this.props.lang;
        const pathname = type === 'header' ? EG_HEADER : EG_FOOTER;

        return `${this.props.configState.globalBase}/${pathname}?lang=${lang}`;
    };

    componentDidMount() {
        const data = this.state.data;
        const url = this.getRequestUrl();
        if (data) {
            this.injectHtmlBlob(data);
        } else {
            axios.get(url).then(res => {
                const responseData = res.data || {};
                this.setState({data: responseData.text});
                navReady(this.configureHeader);
                footerReady(this.configureFooter);
                this.injectHtmlBlob(responseData);
            });
        }
    }

    configureHeader = () => {
        const {lang, userState, configState} = this.props;
        const isLoggedIn = userState.isLoggedIn;
        const accountInfo = userState.accountInfo || {};
        const displayName = accountInfo.displayName || '';
        const _epicGamesNavObserver = root._epicGamesNavObserver || {};
        if (_epicGamesNavObserver && _epicGamesNavObserver.set) {
            _epicGamesNavObserver.set('hideSearch', false);
            _epicGamesNavObserver.set('hideLocale', false);
            _epicGamesNavObserver.set('onSearch', query => {
                root.location.href = `/bing-search?keyword=${query}`;
            });
            _epicGamesNavObserver.set('isLoggedIn', isLoggedIn);
            _epicGamesNavObserver.set('displayName', displayName);
            _epicGamesNavObserver.set('locale', lang.replace(/_/g, '-'));
            _epicGamesNavObserver.set('accountLinks.signInLinks.0.onClick', e => {
                e.preventDefault();
                const encodedState = encodeURIComponent(root.document.URL);
                root.location.href = `${getOrigin()}/login?state=${encodedState}`;
            });
            _epicGamesNavObserver.set('accountLinks.signOutLink.onClick', e => {
                e.preventDefault();
                root.location.href = `${getOrigin()}/logout?state=${
                    configState.globalBase
                }/${lang.replace(/_/g, '-')}`;
            });
        }
    };

    configureFooter = () => {
        const _epicGamesFooterObserver = root._epicGamesFooterObserver || {};
        if (_epicGamesFooterObserver && _epicGamesFooterObserver.set) {
            _epicGamesFooterObserver.set('callToAction', {});
            _epicGamesFooterObserver.set('enableNewsLetter', false);
        }
    };

    getUniqueID = () => {
        const type = this.props.type;
        return `${DIV_CONTAINER_ID}_${type}`;
    };

    injectHtmlBlob = blob => {
        jQuery(`#${this.getUniqueID()}`).append(blob);
    };

    render() {
        return <div id={this.getUniqueID()} />;
    }
}
